// extracted by mini-css-extract-plugin
export default {"TableActions":"TableActions_TableActions__vLnFD","TableAction":"TableActions_TableAction__EXtVV"};